import axios from 'axios';
import { ListResponse, Response } from 'setup/axios/HttpResponse';
import { AddEditHousingRequest, ChangeStatusHousingRequest, HousingListResponse, ProvinceListRequest, SearchHousingRequest } from '../models/HousingList';
import { API_URL } from 'app/utils/common/constants';
import { _convertObjectToQuery } from 'app/utils/helpers';


const housingApi = {
  searchHousing(body: SearchHousingRequest): Promise<ListResponse<HousingListResponse>> {
    const url = `${API_URL}/api/v1/housing/search`;
    return axios.post(url, body);
  },
  convertUrlLocation(body: any): Promise<Response<any>> {
    let param;
    if (typeof body === 'string') {
      param = {
        linkGoogleMaps: body,
        latitude: 0,
        longitude: 0
      }
    } else {
      param = {
        linkGoogleMaps: body.linkGoogleMaps || "",
        latitude: body.latitude || 0,
        longitude: body.longitude || 0
      }
    }
    
    const url = `${API_URL}/api/v1/google-maps/get-address`;
    return axios.post(url, param);
  },
  addEditHousing(body: AddEditHousingRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/housing/save`;
    return axios.post(url, body);
  },
  getListProvince(body: ProvinceListRequest): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/provine/search`;
    return axios.post(url, body);
  },
  changeStatusHousing(body: any): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/housing/change-status`;
    return axios.post(url, body);
  },
  getDispatchActiveByHousingId(housingId: number): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/housing/get-dispatch-active-by-housing-id/${housingId}`;
    return axios.get(url);
  },
  downloadHousingTemplate(): Promise<Blob> {
    const url = `${API_URL}/api/v1/housing/download-housing-template`;
    return axios.get(url, { responseType: 'blob' });
  },
  importHousingsFromExcel(file: File): Promise<Response<any>> {
    const url = `${API_URL}/api/v1/housing/import-housings-from-excel`;
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(url, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  },
};

export { housingApi };

